import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { DutyAssignment } from '../../store/models/DutyAssignment';
import { ColDef } from 'ag-grid-community';
import { InputGroup } from '@blueprintjs/core';
import { observer } from 'mobx-react';
import BaseGrid from '../common/grid/BaseGrid';
import styled from '@emotion/styled';
import { dateFilterNormal, renderGridDateWithDay } from '../../store/utils';

interface DutiesSearchResultProps extends WithTranslateProps {
  duties: Array<Instance<typeof DutyAssignment>>;
  setFilterText: (filter: string) => void;
  filter: string;
  onListDutySelect: (selection: any) => void;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

@observer
class DutiesSearchResult extends React.Component<DutiesSearchResultProps> {
  columns = [
    {
      headerName: this.props.translate(TLCode.DutiesHeaderDate),
      field: 'date',
      sort: 'asc',
      sortedAt: 0,
      cellRenderer: renderGridDateWithDay,
      filterParams: {
        textCustomComparator: dateFilterNormal,
      },
    },
    { headerName: this.props.translate(TLCode.DutiesHeaderHourRange), field: 'dutyType', sort: 'desc', sortedAt: 2 },
    { headerName: this.props.translate(TLCode.DutiesHeaderPharmacyApbNumber), field: 'pharmacyApbNumber', width: 100 },
    {
      headerName: this.props.translate(TLCode.DutiesHeaderPharmacyName),
      field: 'pharmacyName',
      sort: 'asc',
      sortedAt: 1,
    },
    { headerName: this.props.translate(TLCode.DutiesHeaderAddress), field: 'pharmacyAddress' },
    { headerName: this.props.translate(TLCode.DutiesHeaderZip), field: 'pharmacyZip', width: 70 },
    { headerName: this.props.translate(TLCode.DutiesHeaderCity), field: 'pharmacyCity' },
    { headerName: this.props.translate(TLCode.DutiesHeaderPhoneNumber), field: 'pharmacyPhoneNumber' },
  ] as ColDef[];

  buildGridData = () => {
    return this.props.duties.map((d) => ({
      id: d.dutyAssignmentId,
      dutyType: this.props.translate(d.duty!.dutyType!.type === 'DAY' ? TLCode.DutyTypeDay : TLCode.DutyTypeNight),
      dutyId: d.duty!.dutyId,
      date: d.duty!.dutyDate.date,
      pharmacyId: d.pharmacyId,
      pharmacyName: d !== undefined && d.pharmacySimple ? d.pharmacySimple!.name : '',
      pharmacyApbNumber: d !== undefined && d.pharmacySimple ? d.pharmacySimple!.apbNumber : '',
      pharmacyAddress: d !== undefined && d.pharmacySimple ? d.pharmacySimple!.address : '',
      pharmacyCity: d !== undefined && d.pharmacySimple ? d.pharmacySimple!.city : '',
      pharmacyZip: d !== undefined && d.pharmacySimple ? d.pharmacySimple!.zipCode : '',
      pharmacyPhoneNumber: d !== undefined && d.pharmacySimple ? d.pharmacySimple!.mobile : '',
    }));
  };

  render() {
    const { setFilterText, filter, onListDutySelect } = this.props;

    return (
      <Container>
        <InputGroup
          placeholder="Filter..."
          leftIcon="search"
          value={filter}
          onChange={(e) => setFilterText(e.target.value)}
        />
        <BaseGrid
          columnDefs={this.columns}
          rowData={this.buildGridData()}
          keyName={'id'}
          quickFilterText={filter}
          onRowClicked={(data) => onListDutySelect(data.data)}
          i
        />
      </Container>
    );
  }
}

export default withTranslate(DutiesSearchResult);
